import { z } from 'zod'
import {
  learningArtifactVerifyHashResponseSchema,
  type LearningArtifactVerifyHashResponse,
} from './learning-artifacts-write'

export const LEARNING_ARTIFACTS_BINARY_CONTRACT_VERSION = '1.0.0' as const

export const learningArtifactContentResponseSchema = learningArtifactVerifyHashResponseSchema
export const learningArtifactDeliveryResponseSchema = z.unknown()
export const learningExportPackageDeliveryResponseSchema = z.unknown()

export type LearningArtifactContentResponse = LearningArtifactVerifyHashResponse
export type LearningArtifactDeliveryResponse = z.infer<typeof learningArtifactDeliveryResponseSchema>
export type LearningExportPackageDeliveryResponse = z.infer<typeof learningExportPackageDeliveryResponseSchema>
